import React from 'react';

const LinkCard = ({ label, safety, description }) => {
  const borderColor = {
    green: 'hover:border-green-500',
    yellow: 'hover:border-yellow-500',
    red: 'hover:border-red-500'
  }[safety];

  const safetyText = {
    green: 'Safe: Verified and secure link.',
    yellow: 'Caution: Insufficient data to determine safety.',
    red: 'Unsafe: Do not click, potential threat detected.'
  }[safety];

  const safetyTextColor = {
    green: 'text-green-400',
    yellow: 'text-yellow-400',
    red: 'text-red-400'
  }[safety];

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg w-80 mx-4 !bg-white" style={{ backgroundColor: '#FFFFFF' }}>
      <span
        className={`block text-center text-lg font-semibold text-cyan-300 border-2 border-transparent rounded-md p-3 transition-all duration-300 cursor-pointer ${borderColor}`}
        style={{ color: '#5EEAD4' }}
      >
        {label}
      </span>
      <p className="mt-4 text-sm text-black" style={{ color: '#000000' }}>
        {description}
      </p>
      <p className={`mt-2 text-sm font-medium ${safetyTextColor}`} style={{ color: safety === 'green' ? '#4ADE80' : safety === 'yellow' ? '#FACC15' : '#F87171' }}>
        {safetyText}
      </p>
    </div>
  );
};

const DemoPage = () => {
  const links = [
    {
      label: "Trusted Site",
      safety: "green",
      description: "A verified and secure website for your cybersecurity needs."
    },
    {
      label: "Unknown Site",
      safety: "yellow",
      description: "This site has limited information available."
    },
    {
      label: "Malicious Site",
      safety: "red",
      description: "Known for phishing and malware distribution."
    }
  ];

  return (
    <div className="text-center text-black bg-white py-8 min-h-screen !bg-white" style={{ backgroundColor: '#FFFFFF', color: '#000000' }}>
      <h1 className="text-4xl font-bold mb-8 text-black" style={{ color: '#000000' }}>
        PhishCloud Demo
      </h1>
      <div
        className="card-container !flex !flex-row flex-nowrap overflow-x-auto justify-center px-4 w-full"
        style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'center', width: '100%' }}
      >
        {links.map((link, index) => (
          <LinkCard
            key={index}
            label={link.label}
            safety={link.safety}
            description={link.description}
          />
        ))}
      </div>
      <p className="mt-8 text-black" style={{ color: '#000000' }}>
        Hover over links to see safety indicators. Red links are non-clickable for your protection.
      </p>
    </div>
  );
};

export default DemoPage;